// SUMMARY: Seven-bar barcode brand symbol with symmetric opacities and optional shimmer

import { cn } from '@/lib/utils'

const BAR_WIDTH = 19.3125
const BAR_STEP = 26.91
const BAR_HEIGHT = 93.125
// INFO: symmetric opacity ramp, brightest in the center
const BARS = [
	{ opacity: 0.05, slot: 'bar-outer' },
	{ opacity: 0.1, slot: 'bar-mid' },
	{ opacity: 0.25, slot: 'bar-inner' },
	{ opacity: 1, slot: 'bar-center' },
	{ opacity: 0.25, slot: 'bar-inner' },
	{ opacity: 0.1, slot: 'bar-mid' },
	{ opacity: 0.05, slot: 'bar-outer' },
] as const

interface BrandMarkProps {
	className?: string
	// INFO: "hover" animates when a `.group` ancestor is hovered, "always" loops continuously
	shimmer?: 'none' | 'hover' | 'always'
}

export function BrandMark({ className, shimmer = 'none' }: BrandMarkProps) {
	return (
		<svg
			viewBox="0 0 181 94"
			aria-hidden="true"
			className={cn(shimmer === 'hover' && 'shimmer-hover', shimmer === 'always' && 'shimmer-always', className)}
		>
			{BARS.map((bar, index) => (
				<rect
					key={index}
					className={bar.slot}
					x={index * BAR_STEP}
					y={0}
					width={BAR_WIDTH}
					height={BAR_HEIGHT}
					fill="currentColor"
					fillOpacity={bar.opacity}
				/>
			))}
		</svg>
	)
}
